import { AppConfig } from '@/models/app-service.model';
import { ViewsInfo } from '@/models/views-info.model';
import { ExtendedWindow } from '@/models/app.model';
import { getImageExtension } from '@/helpers/supportedBrowsers';
import { verQuery } from '@/helpers/assetsVersionForCache';
import ApartmentService from './ApartmentService';
import RouteService from './RouteService';
import ViewerService from './ViewerService';
import ResimoService from './ResimoService';

class AppService {
    static appConfig = (window as unknown as ExtendedWindow).__APP_CONFIG__ as AppConfig;

    routeService: RouteService;

    viewerService: ViewerService | null;

    apartmentService: ApartmentService;

    resimoService: ResimoService;

    resimoDataLoadError: boolean;

    apartmentNotFoundError: boolean;

    viewsInfoLoadError: boolean;

    constructor() {
        this.resimoDataLoadError = false;
        this.apartmentNotFoundError = false;
        this.viewsInfoLoadError = false;
        this.viewerService = null;
        this.routeService = new RouteService();
        this.apartmentService = new ApartmentService();
        this.resimoService = new ResimoService();
    }

    public async setupApartmentService() {
        return this.resimoService.fetchData(
            AppService.getApiEndpoint(), AppService.getApiToken(),
            this.routeService.apartmentName ? this.routeService.apartmentName : '',
        ).then((apartment) => {
            if (apartment != null) {
                this.apartmentService.setData(apartment);
            } else {
                this.apartmentNotFoundError = true;
            }

            AppService.fetchViewsInfo().then((response) => {
                this.apartmentService.setNumberOfViewsFromViewsInfo(response);

                const sources: Array<string> = [];
                const basePath = AppService.getAssetsEndpoint();
                const { mappingName, numberOfViews } = this.apartmentService.apartment;

                for (let i = 1; i <= numberOfViews; i += 1) {
                    sources.push(`${basePath}/${mappingName}_${i}${getImageExtension(AppService.appConfig.hasWebpImages)}?${verQuery}`);
                }

                this.viewerService = new ViewerService(sources);
            }).catch(() => { this.viewsInfoLoadError = true; });
        }).catch(() => {
            this.resimoDataLoadError = true;
        });
    }

    private static fetchViewsInfo() {
        return fetch(`${AppService.getViewsInfoPath()}?${verQuery}`)
            .then((response) => response.json() as Promise<ViewsInfo>);
    }

    public static getAssetsEndpoint() {
        return `${this.appConfig?.endpoints.assets}/views` || '';
    }

    public static getViewsInfoPath() {
        return `${this.appConfig?.endpoints.assets}/ViewsInfo.json` || '';
    }

    public static getApiEndpoint() {
        return this.appConfig?.endpoints.api || '';
    }

    public static getApiToken() {
        return this.appConfig?.token || '';
    }
}

export default AppService;
